export const MAX_AVATARS = 8
export const REQUEST_COUNT = 1
